import { FC } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Divider, Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { useTranslation } from 'react-i18next';

import { IMedicationAdditionalCardProps } from './AdditionalInformationCard.interface';
import './style.scss';

const AdditionalInformationCard: FC<IMedicationAdditionalCardProps> = ({
  drugClassIds,
  conditions,
  synonyms,
  medicationDetails,
  isBanned,
  isShowMedicationExceptionLink,
  linkHref = '',
  linkTitle = '',
}): JSX.Element => {
  const { t } = useTranslation();
  const showLink = isShowMedicationExceptionLink && isBanned && linkHref && linkTitle;

  return (
    <Box className="additional-info-card">
      <div className="additional-info-card__title">Additional Information</div>

      <Divider flexItem />
      {!medicationDetails ? (
        <div className="additional-info-card__default-text">
          Additional information, if any, will be displayed here.
        </div>
      ) : (
        <div className="additional-info-card__card-body">
          <div className="additional-info-card__section">
            <div className="additional-info-card__subtitle">Synonyms</div>
            <div className="additional-info-card__text">
              {synonyms?.length ? synonyms.join(', ') : '-'}
            </div>
          </div>

          <div className="additional-info-card__section">
            <div className="additional-info-card__subtitle">Drug Classes</div>
            <div className="additional-info-card__text">
              {drugClassIds?.length ? drugClassIds.join(', ') : '-'}
            </div>
          </div>

          <div className="additional-info-card__section">
            <div className="additional-info-card__subtitle">Conditions</div>
            <div className="additional-info-card__text">
              {conditions?.length ? (
                <div className="additional-info-card__conditions">
                  <span className="additional-info-card__icon-wrapper">
                    <WarningIcon />
                  </span>
                  {conditions}
                </div>
              ) : (
                '-'
              )}
            </div>
          </div>

          {showLink && (
            <Box className="additional-info-card__section">
              <Box className="additional-info-card__wrapper">
                <HelpOutlineIcon color="success" />
                <p className="caption">{t('medicationLookup.whatIfBanned')}</p>
              </Box>
              <Box className="additional-info-card__wrapper">
                <Button variant="text" href={linkHref} target="_blank">
                  <OpenInNewIcon color="success" />
                  <span className="search-result-card__button_text">{linkTitle}</span>
                </Button>
              </Box>
            </Box>
          )}
        </div>
      )}
    </Box>
  );
};

export default AdditionalInformationCard;
